import intellifi from '../assets/Intellifi.png';
import cmls from '../assets/cmls.png';
import wiseday from '../assets/wiseday.png';
import wisedayFav from '../assets/wiseday-fav.png';
import peoples from '../assets/peoples.png';
import strive from '../assets/strive.png';


export const themes = {
  default: {
    backgroundColor: "#fff",
    textColor: "#333333",
    labelColor: "#00467f",
    navBackgroundColor: "#fff",
    navTextColor: "#ffffff",
    primaryButtonBgColor: "#00467f",
    secondaryButtonBgColor: "#00467f",
    primaryButtonTextColor: "#ffffff",
    latestNewsColor: "#00467f",
    logo: cmls,
    favicon: cmls,
  },
  wiseday: {
    backgroundColor: "#fff",
    textColor: "#333333",
    labelColor: "#003780",
    navBackgroundColor: "#fff",
    navTextColor: "#ffffff",
    primaryButtonBgColor: "#003780",
    secondaryButtonBgColor: "#003780",
    primaryButtonTextColor: "#ffffff",
    latestNewsColor: "#003780",
    logo: wiseday,
    favicon: wisedayFav,
  },
  cmls: {
    backgroundColor: "#fff",
    textColor: "#333333",
    labelColor: "#00467f",
    navBackgroundColor: "#fff",
    navTextColor: "#ffffff",
    primaryButtonBgColor: "#00467f",
    secondaryButtonBgColor: "#03a9f4",
    primaryButtonTextColor: "#ffffff",
    latestNewsColor: "#00467f",
    logo: cmls,
    favicon: cmls,
  },
  intellifi: {
    backgroundColor: "#fff",
    textColor: "#333333",
    labelColor: "#310872",
    navBackgroundColor: "#fff",
    navTextColor: "#333",
    primaryButtonBgColor: "#310872",
    secondaryButtonBgColor: "#310872",
    primaryButtonTextColor: "#fff",
    latestNewsColor: "#310872",
    logo: intellifi,
    favicon: intellifi,
  },
  duca: {
    backgroundColor: "#fff",
    textColor: "#333333",
    labelColor: "#ff4f00",
    navBackgroundColor: "#ff0000",
    navTextColor: "#ffffff",
    primaryButtonBgColor: "#ff4f00",
    secondaryButtonBgColor: "#ff372f",
    primaryButtonTextColor: "#ffffff",
    latestNewsColor: "#ff0000",
    logo: peoples,
    favicon: peoples,
  },
  peoples: {
    backgroundColor: "#fff",
    textColor: "#4C5454",
    labelColor: "#d14f58",
    navBackgroundColor: "#fff",
    navTextColor: "#ffffff",
    primaryButtonBgColor: "#d14f58",
    secondaryButtonBgColor: "#d14f58",
    primaryButtonTextColor: "#ffffff",
    latestNewsColor: "#d14f58",
    logo: peoples,
    favicon: peoples,
  },
  strive: {
    backgroundColor: "#fff",
    textColor: "#563F1B",
    labelColor: "#415a69",
    navBackgroundColor: "#fff",
    navTextColor: "#ffffff",
    primaryButtonBgColor: "#415a69",
    secondaryButtonBgColor: "#415a69",
    primaryButtonTextColor: "#ffffff",
    latestNewsColor: "#415a69",
    logo: strive,
    favicon: strive,
  },
};  